import storeInit from "storeInit";
import {isEmpty} from "lodash";

export default function isWorker(){
  const state = storeInit.getState();

  return !isEmpty(state.worker);
}